import { render, staticRenderFns } from "./AddGrn.vue?vue&type=template&id=5527e5ca&scoped=true&"
import script from "./AddGrn.vue?vue&type=script&lang=js&"
export * from "./AddGrn.vue?vue&type=script&lang=js&"
import style0 from "./AddGrn.vue?vue&type=style&index=0&id=5527e5ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527e5ca",
  null
  
)

export default component.exports